import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { getDocumentRuntime } from '../backend/runtime';
import { openLegacyRealtime } from '../backend/realtime';

const INITIAL = { isConnected: false, reason: 'Live updates unavailable. Use Refresh.' };
const NodeSocketContext = createContext({ ...INITIAL, messages: [] });
export const NodeSocketProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState(INITIAL);
  useEffect(() => {
    let runtime;
    try { runtime = getDocumentRuntime(); } catch { return undefined; }
    return openLegacyRealtime(runtime, process.env.REACT_APP_ODOO17_SOCKET_URL, io, setMessages, setStatus);
  }, []);
  return <NodeSocketContext.Provider value={{ ...status, messages }}>{children}</NodeSocketContext.Provider>;
};
export const useNodeSocket = () => useContext(NodeSocketContext);
